// MIRRORED FILE, twin of src/utils/stockLines.js. Pair registered in `mirroredUtilParity.test.js`
// (PAIRS). The twins differ only in the number parser each side owns (invoiceLineMath's `num` here,
// `num.js` toNum on the server); both read a missing, blank or NaN figure as null.
//
// Which confirmed-order lines are STOCK lines (D185.18, BUSINESS_RULES#order-stock-lines): the
// ones with something drawn from stock (`qtyFromStock > 0`, part-drawn included), counted in the
// order line's own unit. A missing or unreadable draw is "nothing drawn", never a quantity. Pantry
// draws are not stock. The page only enables its Print pick list button by it. Pure.
import { num, roundQty } from './invoiceLineMath';

type OrderLine = { qtyFromStock?: unknown; lineNumber?: unknown } | null | undefined;

/** What the order line draws from stock, in its own unit; null when the figure is missing or unreadable. */
export const stockDrawnOf = (item: OrderLine): number | null => num(item?.qtyFromStock);

/** True when more than nothing is drawn from stock. */
export const isStockLine = (item: OrderLine): boolean => (stockDrawnOf(item) ?? 0) > 0;

/**
 * The order's stock lines in order-line number order (a line with no number keeps its place by
 * position): `{ lineNumber, item, quantity }`, quantity = the drawn figure, rounded once.
 */
export function stockLinesOf<T extends OrderLine>(items: T[] | null | undefined) {
  return (Array.isArray(items) ? items : [])
    .map((item, position) => ({ item, position, lineNumber: num(item?.lineNumber) ?? position + 1 }))
    .filter(({ item }) => isStockLine(item))
    .sort((a, b) => a.lineNumber - b.lineNumber || a.position - b.position)
    .map(({ item, lineNumber }) => ({ lineNumber, item, quantity: roundQty(stockDrawnOf(item) as number) }));
}
